module.exports = __webpack_public_path__ + "6d8fe57674a08d7ccdf4d29fc08b95a7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/googley-13.png
// module id = 2029
// module chunks = 0